import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Components
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import BackgroundEffects from './components/Layout/BackgroundEffects';

// Pages
import Home from './pages/Home';
import Services from './pages/Services';
import Portfolio from './pages/Portfolio';
import About from './pages/About';
import Contact from './pages/Contact';

// Styles
import './styles/globals.css';
import './styles/cyberpunk-theme.css';
import './styles/animations.css';

// Importamos los componentes necesarios para la página 404
import NeonText from './components/UI/NeonText';
import CyberButton from './components/UI/CyberButton';

function App() {
    return (
        <Router>
            <div className="cyberpunk-app">
                {/* Efectos de fondo globales */}
                <BackgroundEffects />

                {/* Navegación */}
                <Navbar />

                {/* Contenido principal con rutas */}
                <main className="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/portfolio" element={<Portfolio />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />

                        {/* Ruta de fallback para 404 */}
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </main>

                {/* Footer */}
                <Footer />
            </div>
        </Router>
    );
}

// Componente simple para página 404
const NotFound: React.FC = () => {
    return (
        <div className="not-found-page">
            <div className="container">
                <div className="not-found-content">
                    <NeonText variant="magenta" size="large">
                        // ERROR_404
                    </NeonText>
                    <h1>Página No Encontrada</h1>
                    <p>La ruta solicitada no existe en el sistema.</p>
                    <CyberButton variant="cyan" to="/">
                        Volver al Inicio
                    </CyberButton>
                </div>
            </div>
        </div>
    );
};

export default App;
